<subject-access-request-warning *ngIf="sarNotificationCanBeViewed"></subject-access-request-warning>

<div class="flex flex-1 flex-wrap align-items-center justify-content-between pb-2">
    <h2 class="m-0"><ng-content></ng-content></h2>

    <div *ngIf="limitedAccessInfo?.im1System" class="flex align-items-center p-1 pl-3 pr-3 last-updated">
        <i class="mi mi-medical-record mr-2" [style.font-size]="'2em'"></i>

        <ng-container *miproLoading="initializing; diameterPx: '24px'">
            <span class="mr-2">
                <b>{{ lastUpdated?.im1System }}</b> Last Updated: {{ lastUpdated?.lastUpdateDate }}
            </span>

            <a *ngIf="limitedAccessInfo?.isPatientLogged && limitedAccessInfo?.hasLimitedAccess !== null" (click)="accessRequire()" class="name-icon-link">
                <i
                    *ngIf="limitedAccessInfo?.hasLimitedAccess === false"
                    class="mi-svg mi-svg-cloud-check-green"
                    [ngStyle]="{ color: '#30edbb', 'font-size': '27px' }"
                    pTooltip="Full medical record access has been requested"
                    tooltipPosition="left"></i>
                <i
                    *ngIf="limitedAccessInfo?.hasLimitedAccess === true"
                    class="mi-svg mi-svg-cloud-x-red"
                    [ngStyle]="{ color: '#d32f2f', 'font-size': '27px' }"
                    pTooltip="You have limited access to NHS Data. Click to request more access"
                    tooltipPosition="left"></i>
            </a>
        </ng-container>
    </div>
</div>

<patient-watch (patientIdChanged)="changedPatient()"></patient-watch>